import { render, staticRenderFns } from "./shipmentDisplayHX.vue?vue&type=template&id=4047955c&scoped=true"
import script from "./shipmentDisplayHX.vue?vue&type=script&lang=js"
export * from "./shipmentDisplayHX.vue?vue&type=script&lang=js"
import style0 from "./shipmentDisplayHX.vue?vue&type=style&index=0&id=4047955c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4047955c",
  null
  
)

export default component.exports